import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminApplications = lazy(() => import("@/pages/admin/AdminApplications"));

export const Route = createFileRoute("/admin/applications")({
  component: AdminApplications,
});
